import { css } from "@compiled/react";
import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import ContentBlock from "@/components/wpl/content-block/src";
import { DataEventProps, Row } from "@/libraries/wpl/foundations/src";

const sectionStyles = css({
    "color": "#ffffff",
    "backgroundImage":
        "url(https://wac.stg.internal.atlassian.com/dam/jcr:8a9ac4bd-71f9-4af4-b859-f9c132e12f80/JSW_CTA_bg.png)",
    "backgroundPosition": "center",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "cover",
    "padding": "32px 0",
    "@media only screen and (max-width: 767.98px)": {
        padding: "16px 0",
        backgroundSize: "cover",
        backgroundImage:
            "url(https://wac.stg.internal.atlassian.com/dam/jcr:efb3c307-d2fb-42af-8536-45461774796a/JSW_Blue%20Grid.png)"
    }
});

const rowDesktopContainerStyles = css({
    "display": "flex",
    "padding": "0 120px",
    "marginLeft": "auto",
    "marginRight": "auto",
    "@media only screen and (max-width: 767.98px)": {
        display: "none"
    }
});

const rowMobileContainerStyles = css({
    // display: "flex",
    "paddingLeft": "16px",
    "paddingRight": "16px",
    "@media only screen and (min-width: 768px)": {
        display: "none"
    }
});

const contentBlockStyles = css({
    "> div.text-section": {
        "maxWidth": "800px",
        "margin": "0 auto",
        "> h2": {
            "fontSize": "36px",
            "fontWeight": "500",
            "paddingTop": "16px",
            "lineHeight": "48px",
            "@media only screen and (max-width: 767.98px)": {
                fontSize: "24px",
                lineHeight: "32px",
                marginBlockEnd: "8px"
            }
        },
        "> div.contentBlock-linkFlex": {
            margin: "0 0 22px"
        }
    }
});

const CtaSectionContentBlock = () => {
    const intl = useIntl();
    const linkDataEventProps: DataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware-PaidLpJiraFeatures"
    };

    return (
        <ContentBlock
            css={contentBlockStyles}
            headerType="h2"
            headerText={intl.formatMessage({
                id: "JiraSoftwarePageTemplate.paidLpJswFeatures.ctaSection.buildBetterTogether",
                defaultMessage:
                    "Move fast, stay aligned, and build better - together"
            })}
            orientation="vertical"
            ctaProps={{
                buttonProps: {
                    text: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.paidLpJswFeatures.ctaSection.getItFree",
                        defaultMessage: "Get it free"
                    }),
                    color: "yellow",
                    url: useLocalizedHref("#start-trial"),
                    dataEventProps: linkDataEventProps
                }
            }}
            isCentered
        />
    );
};

const CTASectionPaidLpJswFeatures = () => {
    return (
        <section css={sectionStyles}>
            {/* desktop view */}
            <div css={rowDesktopContainerStyles}>
                <Row layout="12" alignItems="center">
                    <CtaSectionContentBlock />
                </Row>
            </div>
            {/* mobile view */}
            <div css={rowMobileContainerStyles}>
                <Row layout="12" alignItems="center">
                    <CtaSectionContentBlock />
                </Row>
            </div>
        </section>
    );
};

export default CTASectionPaidLpJswFeatures;
